
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.724 18.889a.56.56 0 01.481.273.56.56 0 010 .565.546.546 0 01-.48.273h-9.45a.56.56 0 01-.48-.273.56.56 0 010-.565.546.546 0 01.48-.273h9.45zM22.34 4a.66.66 0 01.66.66v12.68a.66.66 0 01-.66.66H1.66a.66.66 0 01-.66-.66V4.66A.66.66 0 011.66 4h20.68zM8.298 8.444H6.94V14h1.358v-2.237h2.128V14h1.354V8.444h-1.354v2.18H8.298v-2.18zm6.59 0H12.66V14h2.227c.824 0 1.466-.247 1.925-.741.459-.494.688-1.184.688-2.07 0-.88-.229-1.557-.686-2.032-.458-.475-1.1-.713-1.927-.713zm-.274 1.112c.428 0 .76.131.994.394.235.264.352.641.352 1.134 0 .524-.114.919-.343 1.184-.228.266-.563.399-1.003.399h-.634V9.556z","id":"🎨-Color","fill":"currentColor","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}})])
          )
        }
      }
    